"use client";
import InputField from "../../../components/common/InputField"; 
import SelectInput from "../../../components/Select";

 
const AddZoneModal = () => {
  return (
    <div className="w-[655px] p-4 space-y-4">
      <div className="grid grid-cols-6 gap-4">
        <SelectInput className="col-span-3" label={"Zone Name"} name={""} selectOptions={[]} />
        <SelectInput className="col-span-3" label={"Select Tire"} name={""} selectOptions={[]} />
        <SelectInput className="col-span-6" label={"Select Courier Company"} name={""} selectOptions={[]} />
        <SelectInput className="col-span-2" label={"Select Payment Mode"} name={""} selectOptions={[]} />
        <InputField
          label="Capacity"
          type="text"
          className="col-span-2"
          placeholder="50 Order Per day"
        />{" "}
        <InputField
          label="Price Per Shipment"
          type="text"
          className="col-span-2"
          placeholder="Input Field (Optional)"
        />{" "}
      </div>
    </div>
  );
};

export default AddZoneModal;
